import {Component, inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {ButtonComponent} from "../../button/button.component";

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [
    ButtonComponent,
  ],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss'
})
export class AlertDialogComponent {

  dialogRef = inject(DialogRef);
  data = inject(DIALOG_DATA);

  onNoClicked() {
    this.dialogRef.close(false);
  }

  onYesClicked() {
    this.dialogRef.close(true);
  }
}
